import { loadRuntimeConfig } from './runtime-config';

loadRuntimeConfig().then(() => import('./bootstrap')).catch(() => {
  const app = document.querySelector('#app');
  if (!app) return;
  const message = document.createElement('p');
  message.textContent = '应用暂时无法加载，请稍后刷新；若持续失败，请联系管理员检查服务配置。';
  const retry = document.createElement('button');
  retry.textContent = '重新加载';
  retry.addEventListener('click', () => location.reload());
  app.replaceChildren(message, retry);
});
